import { randstr } from '../../lib/Tools'
import createDuck from '../lib/MetagnosticDuck'
import { getReservation, getReservations } from '../lib/APIClient'
import ActionTypes from '../actions/ActionTypes.js'
import { createReservationFromItem } from '../reservations/createReservationFromItem'
import emptyReservation from '../reservations/emptyReservation'

const getId = ({ _id }) => _id || randstr(8)

const _create = (initials, item, tripId, cb) => {
  const r = createReservationFromItem(tripId, item, initials)
  
  const itemKey = r.itemKey
  const id = tripId + itemKey
  
  if (cb) cb(id)

  
  return { id, payload: r, type: ActionTypes.CREATE_ONE_RESERVATIONS }
}

/**
 * 
 */

const duck = createDuck(
  "RESERVATIONS", 
  getReservation, 
  getReservations, 
  { getId, createDoc: _create }, 
  emptyReservation, 
  null, // custom reducers
  { expunge: true }
)

export const createReservation = duck.actions.createDoc
export const receiveReservations = duck.actions.receiveCollection
export const receiveReservation = duck.actions.receiveDoc
export const removeReservation = duck.actions.removeDoc
export const fetchReservations = duck.actions.fetchCollection
export const updateReservation = duck.actions.updateDoc

export default duck

